import $ from "jquery";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

$(function () {

    //ScrollTrigger-------------------------------------------------
    gsap.registerPlugin(ScrollTrigger);

    //backtotop
    $('.backtotop_link').click(function (e) {
        e.preventDefault();
        gsap.to('html, body', {
            duration: 1, scrollTop: 0, ease: 'quart.out', onComplete: function () {
                $('.access_content').focus();
            }
        });
    });

    gsap.to('.backtotop', {
        scrollTrigger: {
            trigger: '.about_sec',
            start: 'top 20%', // trigger物件的頂端(top),碰觸到視窗的中段(center)時啟動
            endTrigger: '.footer',
            // end: 'top 100%',
            toggleActions: "restart reverse restart reverse", // "onEnter onLeave onEnterBack onLeaveBack"
        },
        duration: .4,
        opacity: 1,
        display: 'block',
        ease: 'power2.out',
    })

    if ($(window).width() > 480) {
        //aside_navigation
        gsap.to('.content_func_row', {
            duration: .4,
            scrollTrigger: {
                trigger: '.content_func_row',
                start: 'top top',
                end: "+=5000",
                scrub: 1,
                pin: true,
            },
        });
    }
});